/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { useCustomer } from '@components/contexts/CustomerContext';
import { Avatar } from '@mui/material';
import Image from 'next/image';
import { FC } from 'react';

import { ProfileAvatarSkeleton } from './SidebarProfileSkeletons';

const SidebarProfileAvatar: FC = () => {
  const { loading } = useCustomer();

  if (loading) {
    return <ProfileAvatarSkeleton />;
  }

  return (
    <Avatar sx={{ width: 33, height: 33, bgcolor: 'common.white' }}>
      <Image src="/illustrations/user.svg" layout="fill" />
    </Avatar>
  );
};

export default SidebarProfileAvatar;
